<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Upload Images</h3>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>

    <div class="modal-body">
      <!-- Drop zone -->
      <div
        class="drop-zone"
        [class.dragging]="isDragging"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="triggerFileInput()"
      >
        <div class="drop-zone-content">
          <div class="upload-icon">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </div>
          <p class="drop-zone-text">
            <span class="highlight">Click to select</span> or drag and drop
            images here
          </p>
          <p class="drop-zone-hint">PNG, JPG, GIF up to 10MB</p>
        </div>
      </div>

      <!-- Hidden file input -->
      <input
        type="file"
        id="file-input"
        multiple
        accept="image/*"
        (change)="onFileSelected($event)"
        style="display: none"
      />

      <!-- Image previews -->
      <div class="image-previews" *ngIf="uploadedImages.length > 0">
        <div class="preview-header">
          <h4>Selected Images ({{ uploadedImages.length }})</h4>
        </div>
        <div class="preview-grid">
          <div
            class="preview-item"
            *ngFor="let image of uploadedImages; let i = index"
          >
            <div class="preview-image-wrapper">
              <img [src]="image.preview" [alt]="image.name" />
              <button class="remove-btn" (click)="removeImage(i)">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            <div class="preview-info">
              <p class="preview-name" [title]="image.name">{{ image.name }}</p>
              <p class="preview-size">{{ formatFileSize(image.size) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="secondary" (click)="onClose()">Cancel</button>
      <button
        class="primary"
        (click)="onUpload()"
        [disabled]="uploadedImages.length === 0"
      >
        Upload {{ uploadedImages.length > 0 ? '(' + uploadedImages.length + ')' : '' }}
      </button>
    </div>
  </div>
</div>

